import React from 'react';
import clsx from 'clsx';
import { DropDown, DropDownItem } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import FieldErrorText from '../FieldErrorText/FieldErrorText';

const RequiredDropDown = ({
  header, options, errorText, isValid, handleChange, testId
}) => {
  if (!options?.length) {
    return null;
  }

  return (
    <div data-testid={testId}>
      <DropDown
        className={clsx('p2p-drop-down', !isValid && 'p2p-drop-down--invalid')}
        header={header}
        hideOnSelection
        expandOnClick
      >
        {options.map((it) => (
          <DropDownItem
            key={it}
            onClick={() => {
              handleChange(it);
            }}
          >
            {it}
          </DropDownItem>
        ))}
      </DropDown>
      <FieldErrorText hidden={isValid}>{errorText}</FieldErrorText>
    </div>
  );
};

export default RequiredDropDown;

RequiredDropDown.propTypes = {
  header: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  isValid: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  errorText: PropTypes.string.isRequired,
  testId: PropTypes.string
};

RequiredDropDown.defaultProps = {
  testId: 'required-dropdown'
};
